(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/onboarding/assets/javascripts/events/add-tooltip-event.js') >= 0) return;  svs.modules.push('/components/lb-utils/onboarding/assets/javascripts/events/add-tooltip-event.js');
"use strict";

const VerifyType = svs.components.lbUtils.verify.constants.VerifyType;
const verifyObject = svs.components.lbUtils.verify.verifyObject;
const BaseTooltipEvent = svs.components.lbUtils.onboarding.events.BaseTooltipEvent;
const TooltipEventType = svs.components.lbUtils.onboarding.events.constants.TooltipEventType;
class AddTooltipEvent extends BaseTooltipEvent {
  constructor(props) {
    verifyObject(props).schema({
      target: VerifyType.NotEmptyString,
      texts: [VerifyType.NotEmptyString],
      placement: VerifyType.NotEmptyString
    });
    super(TooltipEventType.Add, props);
  }
}

setGlobal('svs.components.lbUtils.onboarding.events.AddTooltipEvent', AddTooltipEvent);

 })(window);